export default __webpack_public_path__ + "static/media/TiqLogo.0d7f032a.svg";